// Export CSV delle tabelle Crud: il file lo scrive il backend (POST csv-exports).
// Nessun import dello store: Crud è caricato dal router (v. rule _always.md § Utility caricate
// dal router).

// Righe massime di una selezione manuale: viaggiano nel corpo della richiesta (backend: CsvExportsAPIController::MAX_ITEMS)
export const MAX_EXPLICIT_ITEMS = 5000

export function exportFileName(modelDef, advanced, now = new Date()) {
	const pad = n => String(n).padStart(2, '0')
	const stamp = `${now.getFullYear()}${pad(now.getMonth() + 1)}${pad(now.getDate())}_${pad(now.getHours())}${pad(now.getMinutes())}`
	return `${modelDef}_${stamp}${advanced ? '_righe' : ''}.csv`
}
